import { apiInputSchema, ApiType } from '@portals/shared/admin/ApiDto';
import { URL_MATCHER } from '@portals/shared/common/matchers';
import { INVALID_URL } from '@portals/shared/common/messages';
import { array, literal, string, z } from 'zod';

export const apiEnvironmentForm = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  isInternal: z.boolean(),
  isDefault: z.boolean(),
});

export type ApiEnvironmentFormInput = z.input<typeof apiEnvironmentForm>;
export type ApiEnvironmentFormOutput = z.output<typeof apiEnvironmentForm>;

// Extend the shared schema for admin-specific overrides
export const apiForm = apiInputSchema.extend({
  productPageUrl: string().max(120).regex(URL_MATCHER, INVALID_URL).optional().or(literal('')),
  termsOfUse: string().optional(),
  description: string().max(400).optional(),
  icon: string().default('api'),
  ordering: string().regex(/\d+/, 'Must be an integer').default('999').or(literal('')),
  tags: array(string()),
});

export type ApiFormOutput = z.output<typeof apiForm>;
export type ApiFormInput = z.input<typeof apiForm>;

export interface ApiStatisticsDetailLevel {
  public: number;
  internal: number;
  partner: number;
  unexposed: number;
}
export interface StageCount {
  launched: number;
  upcoming: number;
  deprecated: number;
  decommissioned: number;
}

export interface ApiRow {
  id: string;
  name: string;
  slug: string;
  stage: string;
  classification: string;
  isPublic: string;
  exposure: string;
  createdAt: Date;
  tags: string[];
  owner: string;
  type: ApiType;
}
